import startOfYear from 'date-fns/start_of_year';
import endOfYear from 'date-fns/end_of_year';
import compareAsc from 'date-fns/compare_asc';

import dateFns from 'date-fns';

import {format as formatDate} from 'date-fns/format';
import eachDay from 'date-fns/each_day'

import {getDate as gDate, getTime} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';

// import {format as formatDate} from 'date-fns/format';
//
import {integerToFloat} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
import {_} from 'underscore';
import {getDate, DATE_FORMAT} from "../../../../../app/Shared/Resources/Assets/js/helpers/format.date";

import {friendly} from "../../../../../app/Shared/Resources/Assets/js/helpers/strings";
import {stringToProperty} from "../../../../../app/Shared/Resources/Assets/js/helpers/object.formats";

export function SalesComponent(parameters, infoType) {
	if (!(typeof infoType !== 'undefined' && infoType !== null)) {
		infoType = 'sales';
	}

	let months = {
		'01': 'Jan',
		'02': 'Feb',
		'03': 'Mar',
		'04': 'Apr',
		'05': 'May',
		'06': 'Jun',
		'07': 'Jul',
		'08': 'Aug',
		'09': 'Sep',
		'10': 'Oct',
		'11': 'Nov',
		'12': 'Dec'
	};

	function eachHour(start, end) {
		let startTime = dateFns.startOfToday(),
			hours = {};

		for (let i = 0; i < 24; i++) {
			hours[i] = startTime;

			startTime = dateFns.addHours(startTime, 1);
		}
		return hours;
	}

	/**
	 * A list of month names from start oof year (or date) to end
	 * @todo finish this for monthly list
	 * @param start
	 * @param end
	 */
	function eachMonth(start, end) {
		let startPosition = start,
			endPosition = end; //one year from start;

		for (let month in months) {
			this.log('month', month);
		}

	}

	/**
	 * A list of days from the start of the month (or date) to the end
	 * @param start
	 * @param end
	 */
	function eachDayOfMonth(start, end) {
		return eachDay(start, end);
	}

	/**
	 * List of years from start (or date set) to end
	 * @param start
	 * @param end
	 */
	function eachYear(start, end) {
		let yearsObject = {},
			startDate = new Date(start),
			count = 0;

		while (startDate <= end) {
			yearsObject[count] = startDate;
			// array.push(startDate);

			startDate = dateFns.addYears(startDate, 1);
			++count;
		}
		return yearsObject;
	}

	return {
		parameters: parameters,
		formats: {
			hours: 'HH:mm',
			days: 'ddd',
			monthly_days: 'ddd',
			monthly: 'DD',
			yearly: 'YYYY'
		},
		settings: {
			sale_total: 0,
			sale_count: 0,
			title: '',
			file_name: '',
			start_date: '',
			date_range: {
				params: {
					start: new Date(),
					end: new Date()
				},
				data: {
					start: '',
					end: ''
				}

			},
			frequency: '',
			chart_labels: [],
			chart_label_data: [],
			chart_data: [],
			sale_records: [],
		},
		/**
		 * Set the date range, frequency and labels for the chart
		 * @param settings
		 */
		init: function (settings) {
			let _this = this;

			_this.settings.sale_count = 0;

			//get start of week
			this.setDateRange(settings).setFrequency().createLabels();
		},
		_setDateRangeRaw(settings, date_range) {
			if (!settings.hasOwnProperty('date_range')) {
				settings['date_range'] = Object;
			}
			if (!settings.date_range.hasOwnProperty('data')) {
				settings.date_range['data'] = Object;
			}
			// console.log('_this.date_range', _this.date_range);
			this.settings['date_range']['data'] = settings['date_range']['data'] = {
				end: date_range.end.date,
				start: date_range.start.date,
			};
			// console.log('settings',settings);
			// console.log('this.settings',this.settings);
			return settings;
		},
		/**
		 * If a date range is set then use it
		 * @param settings
		 * @returns {setDateRange}
		 */
		setDateRange(settings) {
			this.settings.date_range = {
				data: settings.date_range.data,
				params: settings.date_range.data
			};
			
			// console.log('this.settings.date_range',this.settings.date_range);
			return this;
		},
		/**
		 * Sales counter
		 * @param items
		 * @param settings
		 * @returns {{sale_total: number, title: string, start_date: string, date_range: {params: {start: Date, end:
		 *     Date}, data: {start: string, end: string}}, frequency: string, chart_labels: Array, chart_label_data:
		 *     Array, chart_data: Array}|settings|{sale_total, title, start_date, date_range, frequency, chart_labels,
		 *     chart_label_data, chart_data}}
		 */
		setSalesValueFilter(items, settings) {
			let _this = this;

			try {
				// set the title and params if any
				if (_this.hasParams()) {
					_this.init(settings);

					_this.settings.sale_total = items.sale_total;
					_this.settings.sale_count = items.sale_count;
					return _this.createTitle().settings;
				}else{
					throw new Error('Params not set');
				}
			} catch (e) {
				console.error('Error compiling settings:', e);
			}
		},
		/**
		 * Creates ChartData
		 * @param items
		 * @param settings
		 * @returns {*}
		 */
		setChartData(items, settings) {
			let _this = this;

			_this.settings.chart_labels = [];
			_this.settings.chart_label_data = [];
			_this.settings.chart_data = [];
			// set the title and params if any
			try {
				if (this.hasParams()) {
					// console.log('settings', settings);
					this.init(settings);
					// console.log('settings', settings);

					// console.log('dateRangeRecords', dateRangeRecords);
					// prepare the chart records
					for (let i = 0; i < items.length; i++) {
						let data = items[i];

						this.createChartRecords(data);
						// push sales list up
						_this.settings.sale_records.push(data);
						_this.settings.sale_total = _this.settings.sale_total + data.total;

					}
					// console.log('this.settings', this.settings);
					this.settings.dataSet = items;
					_this.settings.sale_count = items.length;
					return this.createTitle().settings;
					// return _this.settings;
				}
				else {
					throw new Error('No params have been sent. Check initialisation of parent');
				}

			} catch (error) {
				console.error('Cannot initialise procedure. Cancelling execution:', error);
			}

			// iterate though list getting value for each label
		},
		/**
		 * Compile records to send to charts
		 * @@namespace data
		 * @property {object}  data
		 * @property {string}  data.created_at
		 */
		createChartRecords(data) {
			let _this = this,
				dateEntered = '',
				position = -1;

			switch (parameters.frequency) {

				case 'daily': // list hours
					dateEntered = dateFns.format(dateFns.startOfHour(data.created_at), _this.formats.hours);
					break;
				case 'weekly': // list day names
					dateEntered = dateFns.format(dateFns.startOfDay(data.created_at), _this.formats.days);
					break;
				case 'monthly_days': // list days of month starting from start date
					dateEntered = dateFns.format(dateFns.startOfDay(data.created_at), _this.formats.monthly_days);
					break;
				case 'monthly': // list month names
					dateEntered = dateFns.format(dateFns.startOfDay(data.created_at), _this.formats.monthly);
					break;
				case 'yearly': // list years
					dateEntered = dateFns.format(dateFns.startOfDay(data.created_at), _this.formats.yearly);
					break;

			}

			position = _this.settings.chart_labels.indexOf(dateEntered);
			if (position > -1) {
				//enter the record
				let total = formatMoney(data.total);

				if (_this.settings.chart_data[position].sales <= 0) {
					_this.settings.chart_data[position].sales = total;

					// console.log('enter total',total, typeof total);
				}
				else {
					let sales = _this.settings.chart_data[position].sales,
						calc = Number(total) + Number(sales);

					_this.settings.chart_data[position].sales = String(calc);
				}

				_this.settings.chart_data[position].records.push(data);
				_this.settings.chart_data[position].count = ++_this.settings.chart_data[position].count;

			}
		},
		/**
		 * creates human readable labels from the chara database entry which is a Date object
		 */
		createLabels() {
			let _this = this;
			if (typeof _this.chart_label_data == 'object') {
				// console.log(parameters.frequency, '_this.chart_label_data', _this.chart_label_data);
				// console.log('_this.chart_label_data', _this.chart_label_data);
				for (let value in _this.chart_label_data) {
					_this.setLabel(_this.chart_label_data[value]);
				}
			}
			return _this;
		},
		/**
		 * creates each label name for the current loop in createLabels
		 * @param value
		 */
		setLabel(value) {
			let _this = this,
				label = '';
			switch (parameters.frequency) {

				case 'daily': // list hours
					label = dateFns.format(value, _this.formats.hours);
					break;
				case 'weekly': // list day names
					label = dateFns.format(value, _this.formats.days);

					break;
				case 'monthly_days': // list days of month starting from start date
					label = dateFns.format(value, 'ddd');

					break;
				case 'monthly': // list month names
					label = dateFns.format(value, 'DD');

					break;
				case 'yearly': // list years
					label = dateFns.format(value, 'YYYY');

					break;

			}
			_this.settings.chart_labels.push(label);
			_this.settings.chart_data.push({
				label: label,
				records: [],
				sales: 0,
				count: 0
			});
			// console.log(parameters.frequency,'_this.settings.chart_labels',_this.settings.chart_labels);
		},
		/**
		 * Sets the date range for processing
		 * @returns {setFrequency}
		 */
		setFrequency() {
			this.settings.frequency = parameters.frequency;
			// console.log('this.settings.date_range.data', this.settings.date_range.data);
			switch (parameters.frequency) {
				case 'weekly': // list day names
					// this.settings.date_range.data.start = this.startOfWeek(this.settings.date_range.params.start);
					// this.settings.date_range.data.end = this.endOfWeek(this.settings.date_range.params.end);

					// console.log('this.settings.date_range.data', this.settings.date_range.data);

					this.chart_label_data = dateFns.eachDay(this.settings.date_range.data.start, this.settings.date_range.data.end);

					break;
				case 'monthly_days': // list days of month starting from start date

					this.chart_label_data = eachDayOfMonth(this.settings.date_range.data.start, this.settings.date_range.data.end);

					break;
				case 'monthly': // list month names

					this.chart_label_data = dateFns.eachDay(this.settings.date_range.data.start, this.settings.date_range.data.end);

					break;
				case 'yearly': // list years

					this.chart_label_data = eachYear(this.settings.date_range.data.start, this.settings.date_range.data.end);

					break;
				case 'daily': // list hours

					this.chart_label_data = eachHour(this.settings.date_range.data.start, this.settings.date_range.data.end);
			}
			return this;

		},

		createTitle() {
			let _this = this,
				start_title = gDate(_this.settings.date_range.data.start, 'tiny'),
				end_title = gDate(_this.settings.date_range.data.end, 'tiny');

			// console.log('_this.settings.sale_count',_this.settings.sale_count);

			this.settings.file_name = friendly(`${_this.settings.frequency} ${start_title} ${end_title}`);

			_this.settings.sale_total = integerToFloat(_this.settings.sale_total);
			//
			if (infoType === 'sales') {
				_this.settings.title = `sales ${_this.settings.frequency}`;
			}
			else {
				_this.settings.title = `${_this.settings.sale_count} sales ${_this.settings.frequency}`;
			}
			if (parameters.frequency != 'daily' || parameters.frequency != 'yearly') {
				_this.settings.title = `${_this.settings.title}<br> ${start_title} - ${end_title}`
			}
			else {
				_this.settings.title = `${_this.settings.title}<br> ${start_title}`
			}

			return _this;
		},
		recordInDateRange(record) {
			let record_start_date = new Date(record.created_at),
				start_date_range_defined = new Date(this.settings.date_range.data.start),
				end_date_range_defined = new Date(this.settings.date_range.data.end),
				isAfter = 1,
				isBefore = -1,
				isSame = 0,

				// returns 1 if 1st is after 2nd
				// returns -1 if 1st is before 2nd
				// returns 0 if identical
				compareStart = compareAsc(record_start_date, start_date_range_defined),
				compareEnd = compareAsc(record_start_date, end_date_range_defined)
				// ,
				// result = (compareStart > isBefore) && (compareEnd <= isSame  )
			;
			// console.log('record_start_date',record_start_date,'db',record.created_at);
			// console.log('start_date_range_defined',start_date_range_defined,'compareStart',compareStart);
			// console.log('end_date_range_defined',end_date_range_defined,'compareEnd',compareEnd);
			//
			//
			// console.log('result',result);

			return (compareStart > isBefore) && (compareEnd <= isSame);
		},
		compileSalesList(sale_records, schema) {
			let records = [],
				json_fields = {};

			for (let i = 0; i < sale_records.length; i++) {

				/**
				 * @namespace saleRecord
				 * @property saleRecord.sale
				 */
				let saleRecord = sale_records[i],
					schemaData = {}
				;

				for (let item = 0; item < schema.fields.length; item++) {

					let schemaElement = schema.fields[item],
						value = stringToProperty(schemaElement.field_path, saleRecord);
					
					// console.log('saleRecord',saleRecord);

					if (schemaElement.type == 'datetime') {
						value = getDate(value, DATE_FORMAT.date_time.short);
					}
					else if (schemaElement.type == 'money') {
						value = formatMoney(value);
					}

					schemaData[schemaElement.field] = value;
				}
				records.push(schemaData);
			}
			for (let item = 0; item < schema.fields.length; item++) {
				let schemaElement = schema.fields[item];
				json_fields[schemaElement.field] = schemaElement.data_type;

			}
			// console.log('records', records);
			return {
				json_data: records || null,
				json_fields: json_fields
			};
		},
		hasParams: function () {
			return (typeof parameters !== 'undefined' && parameters !== null);
		},
		startOfWeek(date) {
			return dateFns.startOfWeek(date);
		},
		endOfWeek(date) {
			return dateFns.endOfWeek(date);
		},
		startOfMonth(date) {
			return dateFns.startOfWeek(date);
		},
		endOfMonth(date) {
			return dateFns.endOfMonth(date);
		},
		startOfYear(date) {
			return dateFns.startOfYear(date);
		},
		endOfYear(date) {
			return dateFns.endOfYear(date);
		},
		startOfDay(date) {
			return dateFns.startOfDay(date);
		},
		endOfDay(date) {
			return dateFns.endOfDay(date);
		},
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/modules/SalesComponent.js